
import Vuex from 'vuex'




export const store =  new Vuex.Store({
	state: {
		rightView: 'user-list',
		prop1: '',
		prop2: '',
		userArray: [],
		userComp: '0',
		inviteArray: [],
		inviteComp: '0',



	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2},

		setUsers(state, payload) { state.userArray = payload.info; state.userComp = payload.info1; },
		setUserComp(state, payload) { state.userComp = payload.info1; },

		setInvites(state, payload) { state.inviteArray = payload.info; state.inviteComp = payload.info1; },
		setInviteComp(state, payload) { state.inviteComp = payload.info1; },
		
  	},

	actions: {
		getAllUsers(context, payload) {
			context.commit("setUserComp", { info1: '0' }) 
			axios.get('/admin/utility/getusers')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setUsers", { info: b, info1: '1' }) 
	          	});
		},
		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2 })  },
		getAllInvites(context, payload) {
			context.commit("setInviteComp", { info1: '0' }) 
			axios.get('/admin/utility/getallinvites')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setInvites", { info: b, info1: '1' }) 
	          	});
		},
		
		
		
		
	}

})